import { NotificationType } from '@shared/enums/NotificationType';
import { SortedPage } from '@shared/models/sortedPage';

export interface INotification {
    id: string;
    created: Date;
    title: string;
    body: string;
    link: string;
    notificationType: NotificationType;
}

export class NotificationsFilterModel {
    // The notifications search value
    public searchValue = '';
    // The notification type
    public notificationType = NotificationType.Undefined;
}

export class NotificationsPage extends SortedPage {
    public filterModel: NotificationsFilterModel = new NotificationsFilterModel();
}

export class NotificationsPagedData<T> {
    public notificationLogs = new Array<T>();
}
